import { IComponentOptions } from "angular";
import { ProgressivesDetailMachinesEditComponentController } from "./controller";

export const vsName = "progressivesDetailMachinesEdit";

export const progressivesDetailMachinesEditComponentOptions: IComponentOptions =
  {
    controller: ProgressivesDetailMachinesEditComponentController,
    controllerAs: "componentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      progressiveDefinition: "<",
      progressiveMachineConfigurations: "<",
    },
  };
